/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modules
	var hamburgerMenu = __webpack_require__(1);
	var smoothScroll = __webpack_require__(2);
	var eqHeight = __webpack_require__(3);
	var videoEqheight = __webpack_require__(4);
	var pageTop = __webpack_require__(5);
	var topPage = __webpack_require__(6);
	var mainVis = __webpack_require__(7);
	var newsTicker = __webpack_require__(8);
	var youTube = __webpack_require__(9);
	var playVideo = __webpack_require__(10);
	var fileUpload = __webpack_require__(11);
	var slickSlider = __webpack_require__(12);
	
	// functions
	// - common
	var hamburgermenu = new HamburgerMenu($('.js-hamburger'));
	
	$('.js-height').each(function(){
	  var eqheight = new EqHeight(this);
	});
	
	$('.p-campaign-pickup-items.mod-list').each(function(){
	  var videoEqheight = new videoEqHeight(this);
	});
	
	$('.js-scroll').each(function(){
	  var smoothscroll = new Smoothscroll(this);
	});
	
	$('.js-pagetop').each(function(){
	  var pagetop = new PageTop(this);
	});
	
	$('.js-mv').each(function(){
	  var mainvis = new MainVis(this);
	});
	
	$('.js-news').each(function(){
	  var newsticker = new NewsTicker(this);
	});
	
	$('.js-upload').each(function(){
	  var fileupload = new Upload(this);
	});
	
	$('.js-youtube').each(function(){
	  var youtube = new YouTube(this);
	});
	
	$('.js-video').each(function(){
	  var playvideo = new Video(this);
	});
	
	$('.js-slider').each(function(){
	  var slider = new Slider(this);
	});
	
	// - top page
	if($('.p-top').length){
	  var toppage = new TopPage();
	}
	
	$(function(){
	     $('.image-hover a img').hover(function(){
	        $(this).attr('src', $(this).attr('src').replace('_off', '_on'));
	          }, function(){
	             $(this).attr('src', $(this).attr('src').replace('_on', '_off'));
	   });
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = HamburgerMenu = function(el){
	  this.element = $(el);
	  this.label = $('.js-hamburger-label');
	  this.state = $('.js-hamburger-state');
	  this.menu = $('.js-hamburger-menu');
	  this.win = $(window);
	  this.device;
	  this.checkDevice();
	  this.resize();
	  
	  if(this.device === 'sp'){
	    this.event();
	  }
	};
	HamburgerMenu.prototype.event = function(){
	  var self = this;
	  var state = false, scrollPos;
	  this.label.on('click',function(){
	    if(self.state.prop('checked')){
	      self.state.prop('checked', false);
	    }else{
	      self.state.prop('checked', true);
	    }
	  });
	  this.state.on('change',function(){
	    if($(this).prop('checked')){
	      scrollPos = self.win.scrollTop();
	      $('body').addClass('is-fixed').css({'top': -scrollPos});
	      self.element.addClass('is-active');
	      self.menu.fadeIn('fast');
	    }else{
	      $('body').removeClass('is-fixed').css({'top': 0});
	      window.scrollTo(0, scrollPos);
	      self.element.removeClass('is-active');
	      self.menu.hide();
	    }
	  });
	  this.menu.find('a').on('click',function(){
	    $('body').removeClass('is-fixed').css({'top': 0});
	    self.state.prop('checked',false);
	    self.element.removeClass('is-active');
	    self.menu.hide();
	  });
	  
	};
	HamburgerMenu.prototype.resize = function(){
	  var self = this;
	  this.win.on('resize', function(){
	    self.checkDevice();
	    if(self.device === 'sp'){
	      self.event();
	    }else{
	      self.state.prop('checked',false);
	      self.menu.removeAttr('style');
	    }
	  });
	};
	HamburgerMenu.prototype.checkDevice = function(){
	  var isSP = this.state.is(':visible');
	  if(isSP){
	    this.device = 'sp';
	  }else{
	    this.device = 'pc';
	  }
	}
	


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = Smoothscroll = function(el){
	  this.element = $(el);
	  this.speed = 300;
	  this.event();
	};
	Smoothscroll.prototype.event = function(){
	  var self = this;
	  this.element.on('click',function(e){
	    var href = $(this).attr('href');
	
	    // anchor link
	    if(href !== '#' && href.match(/^\#/)){
	      var target = $(href);
	      self.moveTo(e, target);
	      return false;
	    }
	
	    // include nav
	    if(href.match(/^\u002f#/)){
	      var target = href.split('/#')[1];
	          target = $('#' + target);
	      self.moveTo(e, target);
	    }
	
	  });
	};
	Smoothscroll.prototype.moveTo = function(e, target){
	  if(target.length !== 0){
	    var offset = target.offset().top;
	    $('html,body').animate({scrollTop:offset}, this.speed, 'swing');
	  }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = EqHeight = function(el){
	  this.element = $(el);
	  this.item = this.element.find('.js-height-item');
	  this.group = this.element.attr('data-eqHeight-cls');
	  this.event();
	};
	EqHeight.prototype.event = function(){
	  if(this.group === undefined){
	    this.item.matchHeight();
	  }else{
	    var str = this.group.split(',');
	    for(var i = 0; i < str.length; i++){
	      var item = $('.' + str[i]);
	      this.element.find(item).matchHeight();
	    }
	  }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = videoEqHeight = function(el){
	  this.element = $(el);
	  this.item = this.element.find('.p-campaign-pickup-item');
	  this.group = this.element.attr('.p-campaign-pickup-items.mod-list');
	  this.event();
	};
	videoEqHeight.prototype.event = function(){
	  if(this.group === undefined){
	    this.item.matchHeight();
	  }else{
	    var str = this.group.split(',');
	    for(var i = 0; i < str.length; i++){
	      var item = $('.' + str[i]);
	      this.element.find(item).matchHeight();
	    }
	  }
	};
	


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = PageTop = function(el){
	  this.element = $(el);
	  this.win = $(window);
	  this.doc = $(document);
	  this.event();
	};
	PageTop.prototype.event = function(){
	  var self = this;
	  var visible = 'is-visible';
	  this.win.on('scroll', function(){
	    if($(this).scrollTop() > 200){
	      self.element.addClass(visible);
	    }else{
	      self.element.removeClass(visible)
	    }
	  });
	};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	* トップページのコンストラクタ
	* @constructor
	*/
	module.exports = TopPage = function(){
	  this.state = $('.js-hamburger-state');
	  this.win = $(window);
	  this.device;
	  this.checkDevice();
	  this.resize();
	  this.init();
	};
	
	/**
	* initialize
	*/
	TopPage.prototype.init = function(){
	  var self = this;
	
	  this.event();
	
	  // youtube iframe api
	  if(typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined'){
	    this.ytLoaded = this.getYTapi();
	    this.ytLoaded.done(function(){
	      // メインビジュアル
	      self.initMv($('.js-youtube-bg'));
	      // その他
	      self.initPlayers();
	      // SP
	      $('.js-yt-control').on('click', function(e){
	        e.preventDefault();
	        var parent = $(this).closest('.js-yt');
	        var embedId = parent.attr('data-embed-id');
	        var videoId = parent.attr('data-video-id');
	        if(self.device === 'sp') self.initModal(embedId, videoId);
	      });
	    });
	  }else{
	    // メインビジュアル
	    this.initMv($('.js-youtube-bg'));
	    // その他
	    this.initPlayers();
	    // SP
	    $('.js-yt-control').on('click', function(e){
	      e.preventDefault();
	      var parent = $(this).closest('.js-yt');
	      var embedId = parent.attr('data-embed-id');
	      var videoId = parent.attr('data-video-id');
	      if(self.device === 'sp') self.initModal(embedId, videoId);
	    });
	  }
	};
	
	/**
	* イベント
	*/
	TopPage.prototype.event = function(){
	  var self = this;
	
	  // 画面サイズ
	  this.headerHeight = $('.header').height();
	  this.fixedHeight = $('.fixed').height();
	  this.calcRatio(this.win.height() - this.fixedHeight);
	
	};
	
	/**
	* 動画領域の計算
	* @param {number} - h 起点とする高さ
	*/
	TopPage.prototype.calcRatio = function(h){
	  var self = this;
	
	  if(this.device === 'sp') return;
	
	  // 動画領域
	  $('.js-ratio').each(function(){
	    // 領域
	    var wrapper = h - self.headerHeight;
	
	    // 領域に対する16:9の幅
	    var width = wrapper * 16 / 9;
	    // ブラウザ幅に対する16:9の高さ
	    var height = self.win.width() * 9 / 16;
	
	    if(height > wrapper){
	      $(this).css({'width':width, 'height':wrapper});
	      $('.p-top-outline-item').css({'width':width});
	    }else{
	      $(this).css({'width':'100%', 'height':height});
	    }
	  });
	
	  // コンテンツ領域
	  $('.js-section').each(function(i){
	    var ht;
	    if($(this).hasClass('mod-intro')){
	      ht = self.win.height() - self.fixedHeight;
	    }else{
	      ht = $('.p-top-yt-embed.js-ratio').outerHeight();
	    }
	    $(this).css({
	      'height': ht,
	      'padding-bottom': 0
	    });
	  });
	};
	
	/**
	* get youtube iframe API
	*/
	TopPage.prototype.getYTapi = function(){
	  var defer = $.Deferred();
	  $.getScript('//www.youtube.com/player_api', function(){
	    window.onYouTubeIframeAPIReady = function() {
	      defer.resolve();
	    };
	  });
	  return defer.promise();
	};
	
	/**
	* Mv設定
	* @param {selector} - el jqueryセレクタ
	*/
	TopPage.prototype.initMv = function(el){
	  var self = this;
	
	  if(this.device === 'sp') return;
	
	  this.mvEmbedId = el.attr('data-embed-id');
	  this.mvVideoId = el.attr('data-video-id');
	
	  player = new YT.Player(self.mvEmbedId, {
	    videoId: self.mvVideoId,
	    playerVars: {
	      'autoplay': 1,
	      'controls': 0,
	      'enablejsapi': 1,
	      'iv_load_policy': 3,
	      'disablekb':1,
	      'showinfo':0,
	      'rel':0,
	      'start': 0,
	      'end': 98,
				'playsinline': 1,
	      'modestbranding': 1
	    },
	    events: {
	      'onReady': onPlayerReady,
	      'onStateChange': onPlayerStateChange
	    }
	  });
	
	  function onPlayerReady(e){
	    self.setSizeToMv(self.mvEmbedId);
	    e.target.mute();
	    e.target.playVideo();
	//    e.target.mute();
	  }
	
	  function onPlayerStateChange(e){
	    var status = e.target.getPlayerState();
	    if(status == YT.PlayerState.ENDED){
	      player.mute();
	      player.playVideo();
	//      player.mute();
	    }
	    if(status === 1){
	      self.sns();
	    }
	  }
	
	  self.checkDevice();
	  if(self.device === 'pc'){
	      this.win.on('mousemove', function(e){
	        $('.p-top-mv-scroll').fadeIn(100);
	      });
	  }
	
	};
	
	/**
	* Mv サイズ設定
	* @param {string} - embedId iframe id
	*/
	TopPage.prototype.setSizeToMv = function(embedId){
	  var bw = 1200;
	  var bh = (bw / 16) * 9;
	  var w = this.win.width();
	  var h = this.win.height() - this.fixedHeight - this.headerHeight;
	  var mw = w;
	  var mh = Math.round(bh * (mw / bw));
	   
	  if(mh < h){
	    mh = h;
	    mw = Math.round(bw * (mh / bh));
	  }
	   
	  $('#'+embedId).css({
	    width: mw,
	    height: mh,
	    marginTop: (h - mh) / 2,
	    marginLeft: (w - mw) / 2
	  });
	};
	
	/**
	* その他のプレイヤー設定
	*/
	TopPage.prototype.initPlayers = function(){
	  var self = this;
	
	  if(this.device === 'sp') return;
	
	  // youtube 配列
	  this.data = [];
	  $('.js-yt').each(function(i){
	    var obj = {};
	    obj.embedId = $(this).attr('data-embed-id');
	    obj.videoId = $(this).attr('data-video-id');
	    self.data.push(obj);
	  });
	
	  var ytPlayer = [];
	  var ytPlaying, ytStop, ytPlay;
	
	  for(var i = 0; i < this.data.length; i++){
	    ytPlayer[i] = new YT.Player(this.data[i].embedId, {
	      videoId: this.data[i].videoId,
	      playerVars: {
	        modestbranding: 1,
	        'showinfo': 0,
	        'rel': 0
	      },
	      events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
	      }
	    });
	  }
	
	  function onPlayerReady(e){
	//    self.setSizeToMv(self.mvEmbedId);
	//    e.target.mute();
	//    e.target.playVideo();
	//    e.target.mute();
	  }
	
	  function onPlayerStateChange(e){
	    for(var i = 0; i < self.data.length; i++){
	      var thisState = ytPlayer[i].getPlayerState();
	      if (thisState == 1 && ytPlaying == undefined) {
	        ytPlaying = i;
	      } else if (thisState == 1 && ytPlaying != i) {
	        ytStop = ytPlaying;
	        ytPlay = i;
	      } else {
	      }
	    }
	    // 同時再生があった場合、元々再生していた方を停止する
	    if(ytStop != undefined){
	      ytPlayer[ytStop].pauseVideo();
	      ytStop = undefined;
	    }
	    // 現在再生中のプレーヤー番号を保存しておく
	    if(ytPlay != undefined){
	      ytPlaying = ytPlay;
	      ytPlay = undefined;
	    }
	  };
	
	  function play(ytIndex, seekTime){
	    var ytId = self.data[ytIndex]['videoId'];
	    ytPlayer[ytIndex].loadVideoById(ytId);
	  };
	
	  // onclick
	  $('.js-yt-control').on('click', function(e){
	    e.preventDefault();
	    var parent = $(this).closest('.js-yt');
	    var embedId = parent.attr('data-embed-id');
	    var videoId = parent.attr('data-video-id');
	    var num = embedId.replace(/[^0-9^\.]/g,"");
	    $(this).closest('.js-yt').addClass('is-clicked');
	    play(num, 0);
	    ga('send', {'hitType': 'event','eventCategory': 'YTPlayer','eventAction': 'play','eventLabel': videoId});
	  });
	};
	
	/**
	* モーダル設定
	* @param {string} - embedID iframeに付与されるID
	* @param {string} - videoID YoutubeID
	*/
	TopPage.prototype.initModal = function(embedID, videoID){
	  var self = this;
	
	  var embedID = embedID + '_sp';
	
	  if(!$('.js-modal').length){
	    var html = '';
	    html += '<div class="modal js-modal">';
	    html += '<div class="modal-iframe js-modal-content">';
	    html += '<a href="#" class="modal-close c-bt js-modal-close"><span>閉じる</span></a>';
	    html += '</div>';
	    $('body').append('<div class="modal-overlay js-modal-overlay" />').append(html);
	  };
	
	  this.modal = $('.js-modal');
	  this.modalOverlay = $('.js-modal-overlay');
	  this.modalCloses = $('.js-modal-close, .js-modal-overlay');
	  this.modalHtml = $('.js-modal-content');
	  this.modalEmbed = $('.js-modal-embed');
	
	  this.top = this.win.scrollTop();
	  this.setModalPosition(this.top);
	  this.modalOverlay.addClass('is-active');
	  this.modal.addClass('is-active');
	
	  if(!this.modalEmbed.length){
	    this.modalHtml.prepend('<div class="js-modal-embed" id="' + embedID + '">');
	  }
	
	  window.myPlayer = new YT.Player(embedID, {
	    videoId: videoID,
	    playerVars: {
	      modestbranding: 1,
				playsinline: 1,
	      rel: 0,
	      showinfo: 0,
	      autoplay: 1
	    },
	    events: {
	      'onReady': onPlayerReady,
	      'onStateChange': onPlayerStateChange
	    }
	  });
	
	
	  function onPlayerReady(e){
	//    self.setSizeToMv(self.mvEmbedId);
	    e.target.mute();
	//    e.target.playVideo();
	//    e.target.mute();
	  }
	
	  this.modalOverlay.on('click',function(){
	    self.removeModal();
	    return false;
	  });
	
	  this.modal.on('click','.js-modal-close',function(){
	    self.removeModal();
	    return false;
	  });
	};
	
	/**
	* モーダル閉じる
	*/
	TopPage.prototype.removeModal = function(){
	  this.modalOverlay.removeClass('is-active');
	  this.modal.removeClass('is-active');
	  this.modalHtml.children('iframe').remove();
	}
	
	/**
	* モーダル位置調整
	* @param {number} - _t ScrollTop
	*/
	TopPage.prototype.setModalPosition = function(_t){
	  this.modal.css({
	    'top': _t + this.win.height() / 2 - this.modal.height() / 2
	  });
	}
	
	/**
	* ゼロパディング
	* @param {array}
	* @return {string}
	*/
	TopPage.prototype.zeroPadding = function(array){
	  var num = [];
	  for(var i = 0; i < array.length; i++){
	    num.push(('0' + array[i]).substr(-2));
	  }
	  return num;
	};
	
	/**
	* リサイズ
	*/
	TopPage.prototype.resize = function(){
	  var self = this;
	  var timer = false;
	  this.win.on('resize', function(){
	    if(timer !== false){
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function(){
	      self.checkDevice();
	      if(self.device === 'pc'){
	        self.calcRatio(self.win.height() - self.fixedHeight);
	        self.setSizeToMv(self.mvEmbedId);
	      }else{
	        $('.js-section, .js-ratio, .p-top-mv').removeAttr('style');
	      }
	    },400);
	  });
	
	};
	
	/**
	* デバイスチェック
	*/
	TopPage.prototype.checkDevice = function(){
	  var isSP = this.state.is(':visible');
	  if(isSP){
	    this.device = 'sp';
	  }else{
	    this.device = 'pc';
	  }
	};
	
	/**
	* Twitter
	*/
	TopPage.prototype.sns = function(){
	  var facebook = '<div id="fb-root"></div><script>(function(d, s, id) {var js, fjs = d.getElementsByTagName(s)[0];if (d.getElementById(id)) return;js = d.createElement(s); js.id = id;js.src = "//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.8&appId=986703674807672";fjs.parentNode.insertBefore(js, fjs);}(document, "script", "facebook-jssdk"));<\/script>';
	  var twitter = '<script>!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?"http":"https";if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+"://platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js,fjs);}}(document, "script", "twitter-wjs");<\/script>';
	  $('body').append(facebook + twitter);
	}
	
	/**
	* add_200301
	*/
	$(function(){
		$('.top-rice-list__item').hover(
			function() {
				var thisSerif = $(this).find('.top-rice-list__serif').html();
				$('#chara-serif').html(thisSerif).addClass('active');
			}, function() {
				$('#chara-serif').removeClass('active');
			}
		);
	});


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = MainVis = function(el){
	  this.element = $(el);
	  this.state = $('.js-hamburger-state');
	  this.win = $(window);
	  this.device;
	  this.checkDevice()
	  this.resize();
	  this.event();
	};
	MainVis.prototype.event = function(){
	  var fixed = (this.device === 'pc') ? $('.fixed') : $('.fixed-news'),
	      _h = this.win.height() - $('.header').outerHeight() - fixed.outerHeight();
	  this.element.height(_h);
	};
	MainVis.prototype.resize = function(){
	  var self = this;
	  this.win.on('resize', function(){
	    var timer = false;
	    if(timer !== false){
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function(){
	      self.checkDevice();
	      self.event();
	    },100);
	  });
	};
	MainVis.prototype.checkDevice = function(){
	  var isSP = this.state.is(':visible');
	  if(isSP){
	    this.device = 'sp';
	  }else{
	    this.device = 'pc';
	  }
	}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = NewsTicker = function(el){
	  this.element = $(el);
	  this.event();
	};
	NewsTicker.prototype.event = function(){
	  var self = this;
	
	  var len = this.element.find('li').length, i = 1, ticker;
	
	  function news(){
	    self.element.find('li').removeClass('is-visible');
	    self.element.find('li:nth-child('+i+')').addClass('is-visible');
	    i++;
	    if(i>len){
	      i = 1;
	    }
	    ticker = setTimeout(news, 6000);
	  }
	  news();
	
	  this.element.find('li').hover(function(){
	    clearTimeout(ticker);
	  }, function(){
	    news();
	  });
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/**
	* youtubeのコンストラクタ
	* @constructor
	* @param {selector} - el jqueryセレクタ
	*/
	module.exports = YouTube = function(el){
		this.element = $(el);
		this.target = this.element.find('.js-youtube-embed');
		this.videoId = this.target.attr('data-video-id');
		this.win = $(window);
		this.checkDevice();
		this.resize();
		this.init();
	};
	
	/**
	* initialize
	*/
	YouTube.prototype.init = function(){
		var self = this;
	
		this.element.append('<img class="-pic" src="//i.ytimg.com/vi/'+this.videoId+'/maxresdefault.jpg" alt="">');
	
		if(typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined'){
			this.ytLoaded = this.getYTapi();
			this.ytLoaded.done(function(){
				self.event();
			});
		}
	};
	
	/**
	* get youtube iframe API
	*/
	YouTube.prototype.getYTapi = function(){
		var defer = $.Deferred();
		$.getScript('//youtube.com/player_api', function(){
			window.onYouTubeIframeAPIReady = function() {
				defer.resolve();
			};
		});
		return defer.promise();
	};
	
	/**
	* event
	*/
	YouTube.prototype.event = function(){
		var self = this;
	
		$('.js-youtube-control').on('click', function(e){
			e.preventDefault();
			var embedId = $(this).next().attr('data-embed-id');
			var videoId = $(this).next().attr('data-video-id');
			if(self.device === 'pc'){
				$(this).parent().addClass('is-clicked');
				self.initYTPlayer(embedId, videoId);
			}else{
				self.initModal(embedId, videoId)
			}
		});
	};
	
	/**
	* initialize YT player
	* @param {string} - embedId iframe id
	* @param {string} - videoId youtube video id
	*/
	YouTube.prototype.initYTPlayer = function(embedId, videoId){
		var self = this;
		this.ytPlayer = new YT.Player(embedId, {
			videoId: videoId,
			playerVars: {
				rel: 0,
				showinfo: 0,
				autoplay: 1
			},
			events: {
				'onReady': self.onPlayerReady,
				'onStateChange': self.onPlayerStateChange
			}
		});
	};
	
	YouTube.prototype.onPlayerReady = function(event){
		player.mute();
		var self = this;
	};
	YouTube.prototype.onPlayerStateChange = function(event){
		var self = this;
	};
	
	/**
	* モーダル設定
	* @param {string} - embedID iframeに付与されるID
	* @param {string} - videoID YoutubeID
	*/
	YouTube.prototype.initModal = function(embedId, videoId){
		var self = this;
	
		var embedId = embedId + '_sp';
	
		// modal
		if(!$('.js-modal').length){
			var html = '';
			html += '<div class="modal js-modal">';
			html += '<div class="modal-iframe js-modal-content">';
			html += '<a href="#" class="modal-close c-bt js-modal-close"><span>閉じる</span></a>';
			html += '</div>';
			$('body').append('<div class="modal-overlay js-modal-overlay" />').append(html);
		};
	
		this.modal = $('.js-modal');
		this.modalOverlay = $('.js-modal-overlay');
		this.modalCloses = $('.js-modal-close, .js-modal-overlay');
		this.modalHtml = $('.js-modal-content');
		this.modalEmbed = $('.js-modal-embed');
	
		this.top = this.win.scrollTop();
		this.setModalPosition(this.top);
		this.modalOverlay.addClass('is-active');
		this.modal.addClass('is-active');
		if(!this.modalEmbed.length){
			this.modalHtml.prepend('<div class="js-modal-embed" id="' + embedId + '">');
		}
	
		this.initYTPlayer(embedId, videoId);
	
		this.modalOverlay.on('click',function(){
			self.removeModal();
			return false;
		});
	
		this.modal.on('click','.js-modal-close',function(){
			self.removeModal();
			return false;
		});
	}
	
	/**
	* モーダル閉じる
	*/
	YouTube.prototype.removeModal = function(){
		this.modalOverlay.removeClass('is-active');
		this.modal.removeClass('is-active');
		this.modalHtml.children('iframe').remove();
	}
	
	/**
	* モーダル位置調整
	*/
	YouTube.prototype.setModalPosition = function(_t){
		this.modal.css({
			'top': _t + this.win.height() / 2 - this.modal.height() / 2
		});
	}
	
	/**
	* リサイズ
	*/
	YouTube.prototype.resize = function(){
		var self = this;
		var timer = false;
		this.win.on('resize', function(){
			if(timer !== false){
				clearTimeout(timer);
			}
			timer = setTimeout(function(){
				self.checkDevice();
				if($('.js-modal').length){
					self.top = self.win.scrollTop();
					self.setModalPosition(self.top);
				}
			},1000);
		});
	};
	
	/**
	* デバイスチェック
	*/
	YouTube.prototype.checkDevice = function(){
		this.device = $('.header-logo-nrnl').css('position') == 'absolute' ? 'sp' : 'pc';
	}
	


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/**
	* Videoのコンストラクタ
	* @constructor
	* @param {selector} - el jqueryセレクタ
	*/
	module.exports = Video = function(el){
	  this.element = $(el);
	  this.state = $('.js-hamburger-state');
	  this.target = this.element.find('video');
	  this.win = $(window);
	  this.checkDevice();
	  this.event();
	};
	
	/**
	* event
	*/
	Video.prototype.event = function(){
	  var self = this;
	
	  var poster = this.element.find('video').attr('poster');
	  var $control = this.element.find('.js-video-control');
	
	  $control.css('background-image', 'url('+poster+')').on('click', function(e){
	    e.preventDefault();
	    console.log('123');
	    var $parent = $(this).parent();
	    var videoId = $(this).attr('data-video-id');
	    var $video = $('#'+videoId).get(0);
	    $parent.addClass('is-clicked');
	    $('#'+videoId).attr('controls', true);
	    if($video.paused){
	      $video.play();
	    }else{
	      $video.pause();
	    }
	  });
	};
	
	/**
	* デバイスチェック
	*/
	Video.prototype.checkDevice = function(){
	  var isSP = this.state.is(':visible');
	  if(isSP){
	    this.device = 'sp';
	  }else{
	    this.device = 'pc';
	  }
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/**
	* file uploadのコンストラクタ
	* @constructor
	* @param {selector} - el jqueryセレクタ
	*/
	module.exports = Upload = function(el){
	  this.element = $(el);
	  this.element.find('input[type="file"]').on('change', function(){
	    var val = $(this)[0].files[0].name;
	    $('.js-upload-value').text(val);
	  });
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	/**
	* Sliderのコンストラクタ
	* @constructor
	* @param {selector} - el jqueryセレクタ
	*/
	module.exports = Slider = function(el){
	  this.element = $(el);
	  this.event();
	};
	
	/**
	* event
	*/
	Slider.prototype.event = function(){
	  var self = this;
	    this.element.slick({
	      dots: false,
	      slidesToShow: 1,
	      arrows: true,
	        responsive: [
	          {
	            breakpoint: 767,
	              settings: {
	                adaptiveHeight: true
	              }
	          }
	        ]
	    });
	
	  //resize
	  var timer = false;
	  var currentWidth = window.innerWidth;
	  $(window).resize(function() {
	      if (timer !== false) {
	          clearTimeout(timer);
	      }
	      timer = setTimeout(function() {
	        if (currentWidth == window.innerWidth) {
	            // ウインドウ横幅が変わっていないため処理をキャンセル。
	            return;
	        }
	        currentWidth = window.innerWidth;
	          $('.js-slider').slick('unslick');
	          $('.js-slider').slick({
	              dots: false,
	              slidesToShow: 1,
	              arrows: true,
	                responsive: [
	                  {
	                    breakpoint: 767,
	                    settings: {
	                      adaptiveHeight: true
	                    }
	                  }
	                ]
	            })
	        console.log("resize!");
	      }, 200);
	  });
	
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.js